import { FormikHelpers } from "formik";

export const setFormValue = <T extends unknown>(key: keyof T, value: any, helpers: FormikHelpers<T>) => {
    helpers.setFieldValue(key as string, value);
}